<template>
  <div class="corpo-pagina">

    <!-- =======================
         MODALI
    ======================== -->
    <div id="codeeamilcreate" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons red-text text-darken-4 icon-modal-size">error_outline</i>
          {{ translation('modale.invio.mail.titolo.codeeamilcreate.001') }}
        </h4>
        <p>{{ translation('modale.invio.mail.codice.inviato.conferma') }}</p>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModalCode()" class="modal-close btn-large">
          {{ translation('btn.annulla') }}
        </a>
      </div>
    </div>

    <div id="noinvioemail" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons red-text text-darken-4 icon-modal-size">error_outline</i>
          {{ translation('modale.no.invio.disonibili') }}
        </h4>
        <p>{{ translation('modale.invio.mail.errore.credito') }}</p>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModalError()" class="modal-close btn-large">
          {{ translation('btn.annulla') }}
        </a>
      </div>
    </div>

    <div id="invioemail" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons text-darken-4 icon-modal-size">security</i>
          {{ translation('modale.riepilogo.invio.001') }}
        </h4>

        <table class="modal-table">
          <tr>
            <td>{{ translation('modale.email.disponibili') }}</td>
            <td>{{ rimanentiIniziali }}</td>
          </tr>
          <tr>
            <td>{{ translation('modale.mail.numero.code') }}</td>
            <td>{{ allGuests.length }}</td>
          </tr>
          <tr>
            <td>{{ translation('modale.mail.rimanenti') }}</td>
            <td>{{ rimanentiProvvisori }}</td>
          </tr>

          <tr>
            <td>
              {{ translation('modale.codice.sicurezza') }}
              <h5>{{ codiceSicurezza }}</h5>
            </td>
            <td>
              <div class="input-field">
                <input id="sicurezza" type="text" v-model="codiceSicurezzaDgt">
                <label for="sicurezza">
                  {{ translation('modale.invio.mail.codice.sicur') }} {{ codiceSicurezza }}
                </label>
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <span class="danger-note">
                {{ translation('modale.invio.mail.avviso.no.modify') }}
              </span>
            </td>
          </tr>
        </table>
      </div>

      <div class="modal-footer">
        <a href="#!" @click="invioMail()" :disabled="!isSecurityCodeValid" :class="{ 'disabled': !isSecurityCodeValid }"
          class="btn-large">
          {{ translation('modale.btn.invia.mail') }}
        </a>

        <a href="#!" @click="closeModal()" class="modal-close btn-large">
          {{ translation('btn.annulla') }}
        </a>
      </div>
    </div>

    <!-- =======================
         TITOLO PAGINA
    ======================== -->
    <div class="row">
      <div class="col s12">
        <h4 class="page-title">{{ translation('pagina.lista.mail.titolo') }}</h4>
      </div>
    </div>

    <div class="row">

      <div class="col s3 m3 l3">
        <a v-red-tooltip="translation('btn.invio.massimo.email')" class="btn-small tool-btn ml-2" @click="checkTest()">
          <i class="material-icons">send</i>
        </a>

        <span v-red-tooltip="translation('btn.dowload.xls.pax')">
          <download-excel class="btn-small tool-btn ml-2" :fetch="fetchExportData" :fields="json_fields"
            :name="nameFile">
            <i class="material-icons">file_download</i>
          </download-excel>
        </span>

      </div>

      <div class="col s9 m9 l9">
        <div class="stats-card z-depth-1">

          <div class="stat-item">
            <i class="material-icons tiny-stat-icon teal-text">send</i>
            <div>
              <div class="stat-count">{{ deliveryStats.total }}</div>
              <div class="stat-label">{{ translation('pagina.lista.email.statistiche.002') }}</div>
            </div>
          </div>

          <div class="stat-item">
            <i class="material-icons tiny-stat-icon green-text">check_circle</i>
            <div>
              <div class="stat-count">{{ deliveryStats.success }}</div>
              <div class="stat-label">{{ translation('pagina.lista.email.statistiche.003') }}</div>
            </div>
          </div>

          <div class="stat-item">
            <i class="material-icons tiny-stat-icon red-text">cancel</i>
            <div>
              <div class="stat-count">{{ deliveryStats.fail }}</div>
              <div class="stat-label">{{ translation('pagina.lista.email.statistiche.004') }}</div>
            </div>
          </div>

          <div class="stat-item">
            <i class="material-icons tiny-stat-icon grey-text">schedule</i>
            <div>
              <div class="stat-count">{{ deliveryStats.pending }}</div>
              <div class="stat-label">{{ translation('pagina.lista.email.statistiche.005') }}</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="row">

      <div class="col s12 m12 l12">

        <!-- STATUS -->
        <div class="col s6 m6 l6" style="padding:0;">
          <div class="input-field" style="margin:0;">
            <select class="select-customizzato" v-model="statusFilter">
              <option value="TUTTI">{{ translation('pagina.mail.filtro.status.003') }}</option>
              <option value="SUCCESS">{{ translation('pagina.lista.email.statistiche.003') }}</option>
              <option value="FAIL">{{ translation('pagina.lista.email.statistiche.004') }}</option>
              <option value="PENDING">{{ translation('pagina.lista.email.statistiche.005') }}</option>
            </select>
            <label>{{ translation('pagina.mail.filtro.status.006') }}</label>
          </div>
        </div>

        <!-- SEARCH -->
        <div class="col s6 m6 l6" style="padding:0;">
          <div class="input-field" style="margin:0;">
            <input id="search" type="text" v-model="searchTerm" />
            <label for="search">
              <i class="material-icons suffix">search</i>
              {{ translation('pagina.mail.filtro.status.007') }}
            </label>
          </div>
        </div>

      </div>
    </div>

    <div class="row">

      <div class="col s12 m12 l12">

        <table class="striped responsive-table email-table">
          <thead>
            <tr>
              <th>{{ translation('pagina.mail.titolo.tabella.001') }}</th>
              <th>{{ translation('pagina.mail.titolo.tabella.002') }}</th>
              <th>{{ translation('label.name.pax') }}</th>
              <th>{{ translation('label.surname.pax') }}</th>
              <th>{{ translation('label.email.pax') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="paginatedFlattenedGuests.length === 0">
              <td colspan="5" class="no-data">
                {{ searchTerm || statusFilter !== 'TUTTI'
                  ? translation('pagina.mail.filtro.status.001')
                  : translation('pagina.mail.filtro.status.002')
                }}
              </td>
            </tr>

            <tr v-for="(item, index) in paginatedFlattenedGuests" :key="item.uid + '-' + index">
              <td>{{ item.date }}</td>

              <td class="status-cell">
                <i class="material-icons tiny-stat-icon" :class="getMailStatusClass(item.rawStatus)">
                  {{ getMailStatusIcon(item.rawStatus) }}
                </i>
                <span :class="getMailStatusClass(item.rawStatus)">
                  {{ getMailStatusLabel(item.rawStatus) }}
                </span>
              </td>

              <td>{{ item.name }}</td>
              <td>{{ item.surname }}</td>
              <td>{{ item.email }}</td>
            </tr>
          </tbody>
        </table>

        <pagination-controls v-if="totalPages > 1" :current-page="currentPage" :total-pages="totalPages"
          :items-per-page="itemsPerPage" :str-per-pag="translation('pagination.itemsPerPage')"
          :str-pag="translation('pagination.page')" @page-changed="handlePageChange"
          @items-per-page-changed="handleItemsPerPageChange" />

      </div>
    </div>

  </div>

</template>

<script>
// Importa le dipendenze Vue 2-compatible
import PaginationControls from '@/components/PaginationControls.vue'
import eventSetting from '@/store/eventSettings.js'
import translationStore from '@/store/translations'
// import SubMenuMail from '@/components/SubMenuMail.vue'
import M from 'materialize-css'
import apiService from '@/services/apiService.js'
import loadingStore from '@/store/loading.js'
import useAuthStore from '@/store/authStore.js'
import JsonExcel from 'vue-json-excel'

export default {
  name: 'GuestTableWithPaginator',
  components: {
    PaginationControls,
    //  SubMenuMail,
    'download-excel': JsonExcel // Registra localmente

  },
  data () {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      searchTerm: '',
      statusFilter: 'TUTTI',
      modal: null,
      modalerror: null,
      modalcode: null,
      codiceSicurezza: null,
      codiceSicurezzaDgt: null,
      rimanentiProvvisori: 0,
      rimanentiIniziali: 0,
      totaleEmail: 0,
      mailDataFromServer: [],
      nameFile: null
    }
  },
  computed: {
    // ----------------------------------------------------
    // Accesso agli Store (Vue 2 reattivo e sicuro)
    // ----------------------------------------------------
    translation () {
      if (translationStore && translationStore.getters) {
        return translationStore.getters.traduzione
      }
      return (key) => `[${key}]`
    },

    fullEventData () {
      if (eventSetting && eventSetting.getters) {
        return eventSetting.getters.eventModel || {}
      }
      return {}
    },

    checkBalanceEmail () {
      const guestSend = this.allGuests.length
      // Accesso sicuro a useAuthStore
      const remainEmails = (useAuthStore && useAuthStore.getters && useAuthStore.getters.balance && useAuthStore.getters.balance.remaining) ? useAuthStore.getters.balance.remaining.emails : 0
      return guestSend <= remainEmails
    },

    userUid () {
      // Accesso sicuro a useAuthStore
      return (useAuthStore && useAuthStore.getters) ? useAuthStore.getters.uid || null : null
    },
    // ----------------------------------------------------

    // Uso delle chiavi dinamiche
    json_fields () {
      return {
        [this.translation('pagina.mail.titolo.tabella.001')]: 'date',
        // Assumo che 'pagina.mail.titolo.tabella.002' sia il titolo per lo stato mail
        [this.translation('pagina.mail.titolo.tabella.002')]: 'statusLabel',
        [this.translation('label.name.pax')]: 'name',
        [this.translation('label.surname.pax')]: 'surname',
        [this.translation('label.email.pax')]: 'email'
      }
    },

    isSecurityCodeValid () {
      return this.codiceSicurezza && this.codiceSicurezzaDgt === this.codiceSicurezza
    },

    allGuests () {
      return this.fullEventData.guests || []
    },

    guestsMap () {
      const map = {};
      (this.allGuests || []).forEach(guest => {
        map[guest.uid] = {
          name: guest.name,
          surname: guest.surname,
          email: guest.email
        }
      })
      return map
    },

    deliveryStats () {
      let success = 0
      let fail = 0
      let pending = 0
      let total = 0

      this.enrichedMailList.forEach(mail => {
        const status = mail.rawStatus ? mail.rawStatus.toUpperCase() : 'IN ATTESA'
        total++

        if (status === 'SUCCESS') {
          success++
        } else if (['SYSFAIL', 'FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(status)) {
          fail++
        } else {
          pending++
        }
      })

      return {
        success: success,
        fail: fail,
        pending: pending,
        total: total
      }
    },

    enrichedMailList () {
      const mailGuestList = this.mailDataFromServer || []

      return mailGuestList.map(mailItem => {
        const guestInfo = this.guestsMap[mailItem.guest_id] || {}

        const logMail = mailItem.logMail || {}
        // Usa logMail.date se disponibile, altrimenti createdAt
        const rawDate = logMail.date || logMail.createdAt || mailItem.createdAt
        const date = rawDate
          ? new Date(rawDate).toLocaleString()
          : 'N/D'

        const rawStatus = logMail.status || 'IN ATTESA'

        return {
          uid: mailItem.guest_id,
          name: guestInfo.name || ' - ',
          surname: guestInfo.surname || '',
          email: guestInfo.email || ' - ',
          date: date,
          rawStatus: rawStatus
        }
      })
    },

    filteredFlattenedGuests () {
      const searchTermLower = this.searchTerm.toLowerCase().trim()
      const filterStatus = this.statusFilter.toUpperCase()

      return this.enrichedMailList.filter(guest => {
        const searchMatch = !searchTermLower || (
          (guest.name && guest.name.toLowerCase().includes(searchTermLower)) ||
          (guest.surname && guest.surname.toLowerCase().includes(searchTermLower)) ||
          (guest.email && guest.email.toLowerCase().includes(searchTermLower))
        )

        let statusMatch = true
        if (filterStatus !== 'TUTTI') {
          const guestStatus = guest.rawStatus ? guest.rawStatus.toUpperCase() : 'IN ATTESA'

          if (filterStatus === 'SUCCESS') {
            statusMatch = guestStatus === 'SUCCESS'
          } else if (filterStatus === 'FAIL') {
            statusMatch = ['SYSFAIL', 'FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(guestStatus)
          } else if (filterStatus === 'PENDING') {
            statusMatch = guestStatus !== 'SUCCESS' && !['SYSFAIL', 'FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(guestStatus)
          }
        }

        return searchMatch && statusMatch
      })
    },

    totalPages () {
      return Math.ceil(this.filteredFlattenedGuests.length / this.itemsPerPage)
    },

    paginatedFlattenedGuests () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.filteredFlattenedGuests.slice(start, end)
    }
  },
  watch: {
    searchTerm () {
      // FIX: Reimposta la pagina alla ricerca
      this.currentPage = 1
    },
    statusFilter (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1
        this.initSelect()
      }
    }
  },
  methods: {

    // NUOVO METODO ASINCRONO PER IL DOWNLOAD (USATO DA :fetch)
    async fetchExportData () {
      // 1. Esegue la chiamata API e attende l'aggiornamento dei dati interni
      await this.listCodeMails()

      // 2. Restituisce la mappatura dei dati freschi
      return this.enrichedMailList.map(item => ({
        date: item.date,
        name: item.name,
        surname: item.surname,
        email: item.email,
        statusLabel: this.getMailStatusLabel(item.rawStatus)
      }))
    },

    // ----------------------------------------------------
    // Utility per la UI
    // ----------------------------------------------------
    getMailStatusClass (status) {
      const s = status ? status.toUpperCase() : ''
      if (s === 'SUCCESS') {
        return 'green-text text-darken-2'
      }
      if (['SYSFAIL', 'FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(s)) {
        return 'red-text text-darken-2'
      }
      return 'grey-text text-darken-1'
    },

    getMailStatusLabel (status) {
      const s = status ? status.toUpperCase() : ''
      if (s === 'SUCCESS') {
        return this.translation('pagina.lista.email.statistiche.003')
      }
      if (['SYSFAIL', 'FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(s)) {
        return this.translation('pagina.lista.email.statistiche.004')
      }
      return this.translation('pagina.lista.email.statistiche.005')
    },

    getMailStatusIcon (status) {
      const s = status ? status.toUpperCase() : ''
      if (s === 'SUCCESS') {
        return 'check_circle'
      }
      if (['SYSFAIL', 'FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(s)) {
        return 'cancel'
      }
      return 'schedule'
    },

    initSelect () {
      this.$nextTick(() => {
        const elems = document.querySelectorAll('select')
        M.FormSelect.init(elems)

        document.querySelectorAll('.select-dropdown')
          .forEach(wrapper => {
            wrapper.style.setProperty('height', '3rem', 'important')
          })
      })
    },
    // ----------------------------------------------------
    // Logica di Paginazione
    // ----------------------------------------------------
    handlePageChange (page) {
      this.currentPage = page
    },
    handleItemsPerPageChange (items) {
      this.itemsPerPage = items
      this.currentPage = 1
      this.initSelect()
    },
    // ----------------------------------------------------
    // Logica di Invio Mail
    // ----------------------------------------------------
    async createCodeMails () {
      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
        return
      }

      const uid = this.fullEventData.uid
      const url = process.env.VUE_APP_URL_EVENTS + '/code-mail/create'
      const payload = { event_id: uid }

      const json = await apiService.sendRequestWithBearer('POST', url, token, payload)

      loadingStore.commit('setLoading', false)

      this.codiceSicurezza = null
      this.codiceSicurezzaDgt = null

      if (json && json.message === 'ok') {
        if (json.balance) {
          // Aggiorna il bilancio dello store solo se ha successo
          await useAuthStore.dispatch('newBalance', json.balance)
        }
        this.openModaCode() // Apre la modale di conferma
      }
    },

    invioMail () {
      if (!this.isSecurityCodeValid) return

      // Chiudi la modale di riepilogo e avvia il loading, poi la creazione API
      this.closeModal()
      loadingStore.commit('setLoading', true)
      this.createCodeMails()
    },

    async fetchBalanceAndUpdateStore () {
      loadingStore.commit('setLoading', true)
      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return false
        }

        // Uso sicuro di userUid
        const uid = this.userUid
        if (!uid) {
          return false
        }

        const url = process.env.VUE_APP_URL_EVENTS + '/checkins/get-balance/' + uid

        const balanceRaw = await apiService.sendRequestWithBearer('GET', url, token, null, null)

        let balance = balanceRaw
        if (typeof balanceRaw === 'string') {
          try {
            balance = JSON.parse(balanceRaw)
          } catch (e) {
            return false
          }
        }

        await useAuthStore.dispatch('newBalance', balance)

        return true
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    async checkTest () {
      await this.fetchBalanceAndUpdateStore()

      if (!this.checkBalanceEmail) {
        this.openModalError()
        return
      }

      // Accesso sicuro a useAuthStore
      this.rimanentiIniziali = (useAuthStore && useAuthStore.getters && useAuthStore.getters.balance && useAuthStore.getters.balance.remaining) ? useAuthStore.getters.balance.remaining.emails : 0

      this.rimanentiProvvisori = this.rimanentiIniziali - this.allGuests.length
      this.codiceSicurezza = this.generateFiveDigitString()
      this.codiceSicurezzaDgt = null

      this.openModal()
    },

    generateFiveDigitString () {
      const randomNum = Math.floor(Math.random() * 90000) + 10000
      return String(randomNum)
    },

    // ----------------------------------------------------
    // Logica Modali
    // ----------------------------------------------------
    async openModal () {
      if (this.modal) {
        this.modal.open()
      }
    },

    closeModal () {
      if (this.modal) {
        this.modal.close()
      }
    },
    async openModalError () {
      if (this.modalerror) {
        this.modalerror.open()
      }
    },

    closeModalError () {
      if (this.modalerror) {
        this.modalerror.close()
      }
    },

    async openModaCode () {
      if (this.modalcode) {
        this.modalcode.open()
      }
    },

    closeModalCode () {
      if (this.modalcode) {
        this.modalcode.close()
        // Ricarica per visualizzare le email in coda (o re-fetchare i dati)
        this.listCodeMails()
      }
    },

    // ----------------------------------------------------
    // Recupero Dati Tabella (chiamata API)
    // ----------------------------------------------------
    async listCodeMails () {
      loadingStore.commit('setLoading', true)
      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return
        }

        // Uso sicuro di fullEventData
        const uid = this.fullEventData.uid
        if (!uid) {
          this.mailDataFromServer = []
          return
        }

        const url = process.env.VUE_APP_URL_EVENTS + '/code-mail/list'
        const payload = { event_id: uid }

        const jsonListMail = await apiService.sendRequestWithBearer('POST', url, token, payload)

        if (Array.isArray(jsonListMail)) {
          this.mailDataFromServer = jsonListMail
        } else {
          this.mailDataFromServer = jsonListMail && jsonListMail.content ? jsonListMail.content : []
        }
      } catch (error) {
        this.mailDataFromServer = []
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    // Nuova funzione per impostare in modo sicuro il nome del file
    setFileName () {
      // Accesso sicuro a eventSetting
      const eventName = (eventSetting && eventSetting.getters && eventSetting.getters.nameEvent) ? eventSetting.getters.nameEvent : 'DEFAULT_EVENT'
      this.nameFile = eventName + '_EMAIL_GUESTS.xlsx'
    }
  },

  async mounted () {
    // Caricamento iniziale dei dati per la tabella
    await this.listCodeMails()

    // Inizializzazione di Materialize Modals
    const elems = document.getElementById('invioemail')
    const noinvio = document.getElementById('noinvioemail')
    const codemodal = document.getElementById('codeeamilcreate')

    this.modal = M.Modal.init(elems, {
      onCloseEnd: () => { /* ... */ },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })

    this.modalerror = M.Modal.init(noinvio, {
      onCloseEnd: () => { /* ... */ },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })

    this.modalcode = M.Modal.init(codemodal, {
      onCloseEnd: () => { this.listCodeMails() }, // Ricarica la lista dopo la conferma
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })

    // Inizializzazione di Materialize Select e nome file
    this.initSelect()
    this.setFileName() // Imposta il nome del file in modo sicuro
  }
}
</script>
<style scope>

mini-select input.select-dropdown {
  height: 1px !important;
  line-height: 1px !important;
  padding: 0 !important;
}
.page-title {
  margin-bottom: 10px;
  font-weight: 600;
}
.select-customizzato {
  height: 1px!important;
}
.stats-card {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  background: white;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.stat-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.stat-count {
  font-size: 1.3rem;
  font-weight: bold;
  line-height: 1.1;
}

.stat-label {
  font-size: 0.8rem;
  color: #666;
}

.tiny-stat-icon {
  margin-right: 8px;
  font-size: 22px;
}

.toolbar-panel {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 15px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toolbar-right {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
}

.filter-field {
  min-width: 180px;
}

.tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.email-table {
  border-radius: 0px;
  overflow: hidden;
}

.no-data {
  text-align: center;
  padding: 30px;
  color: #777;
}

.modal-table td {
  padding: 5px 10px;
}

.danger-note {
  color: red;
  font-size: 0.9rem;
}

@media (max-width: 992px) {
  .toolbar-panel {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .toolbar-right {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 600px) {
  .stats-card {
    flex-direction: column;
    gap: 15px;
  }

  .toolbar-right {
    flex-direction: column;
    width: 100%;
  }

  .filter-field {
    width: 100%;
  }
}
</style>
